import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { FindMappingByTypeResponseDto } from "~/gen/api/types"
import { MappingTable } from "~/pages/Brand/OrganizationSettings/Mapping/components/MappingTable.tsx"
import { useFindTypeKeysQuery } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useFindTypeKeysQuery"

type Props = {
  standards: FindMappingByTypeResponseDto[]
}

export const StandardMapping = ({ standards }: Props) => {
  const {
    data: standardsList,
    isLoading,
    isError,
  } = useFindTypeKeysQuery("STANDARD")
  const { t } = useTranslation()
  if (isLoading) {
    return <Loader />
  }
  if (isError) {
    return (
      <InfoBox
        color="red"
        title={t("dataLoad.error.title")}
        message={t("dataLoad.error.message")}
      />
    )
  }
  return (
    <>
      <MappingTable
        types={standards}
        typesList={standardsList.data.map((type) => ({
          ...type,
          deletedAt: type.deletedAt ? new Date(type.deletedAt) : null,
        }))}
        typeName="STANDARD"
      />
    </>
  )
}
